
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides/choosing-a-car/[slug]",
      function () {
        return require("private-next-pages/guides/choosing-a-car/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guides/choosing-a-car/[slug]"])
      });
    }
  